// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__3Ag-x","actions":"GroupTable_actions__jroJ_","deleteModalFooter":"GroupTable_deleteModalFooter__1U8LM"};